import { Component } from '@angular/core';
import { LazyLoadDirective } from '@bn/web-ui';
import { NgStyle } from '@angular/common';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { RouterLink } from '@angular/router';

@Component({
  templateUrl: './unauthorized.page.html',
  styleUrls: ['unauthorized.page.scss'],
  imports: [LazyLoadDirective, NgStyle, ButtonComponent, RouterLink],
})
export class UnauthorizedPage {}
